/**
 * Utility functions for clearing flow-related data from localStorage
 * Used during logout to ensure user data privacy and security
 */
import { errorAnalyticsPayload } from '@/utilities/analytics/errorAnalytics'
import { FlowDefinitionType } from '../types'
/**
 * Clears all flow-related data from localStorage
 * This includes:
 * - Individual flow data (form data, current step, etc.)
 * - Completed flows tracking
 * - Any other flow-related localStorage entries
 */
export function clearAllFlowData(): void {
  if (globalThis.window === undefined) return

  try {
    // Get all localStorage keys
    const keys = Object.keys(localStorage)

    // Filter keys that are flow-related
    const flowKeys = keys.filter((key) => key.startsWith('flow-data-'))

    // Remove all flow-related keys
    flowKeys.forEach((key) => {
      localStorage.removeItem(key)
    })
  } catch (error) {
    console.warn('Error clearing flow data from localStorage:', errorAnalyticsPayload(error))
  }
}

/**
 * Clears data for a specific flow
 * @param flowId - The ID of the flow to clear data for
 */
export function clearFlowData(flowId: FlowDefinitionType): void {
  if (globalThis.window === undefined) return

  try {
    localStorage.removeItem(`flow-data-${flowId}`)
  } catch (error) {
    console.warn(`Error clearing flow data for ${flowId}:`, errorAnalyticsPayload(error))
  }
}
